'use client';

import moment from 'moment';
import {  normalizeIsoDate } from '../../utils/date';
import 'moment/locale/ar';
import { useEffect, useState } from 'react';
moment.locale('ar');

const symbolMap = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  '0': '0'
};
const numberMap = {
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
  '٠': '0'
}

  moment.updateLocale('ar', {
    preparse: function (string: string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match: any) {
          //@ts-ignore
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function(string: string) {
      return string.replace(/\d/g, function(match: any) {
        //@ts-ignore
        return symbolMap[match as any] as string;
      }).replace(/,/g, '،');
    },
    });

export default function DateRenderer({date, format = 'MMM DD, YYYY', fromNow = false, normalize = true}: {date?: string; format?: string; fromNow?: boolean; normalize?: boolean;}) {
  if (!date) return null;

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  },[]);

  if (!mounted) return null;

  const normalizedDate = new Date(date ?  (normalize ? normalizeIsoDate(date as string) : date) : Date.now());
  if (fromNow) {
    const now = Date.now();
    const timestamp = normalizedDate.getTime();
    if ((now - timestamp) < 3600000) return <>يحدث الآن</>
    else return moment(normalizedDate).fromNow();
  }
  return <>{moment(normalizedDate).format(format)}</>;
}